import { EPerformanceFormStatus, EvaluationFormTypes } from '@common/definitions';

export const normalizeIconPath = (icon?: string) => {
  if (!icon) return icon as any;

  const marker = '/globals/attachments/';
  if (icon.includes(marker)) {
    const [, rest = icon] = icon.split(marker);
    return rest;
  }

  if (/^[a-z0-9_-]+\/.+\.png$/i.test(icon)) return icon;

  try {
    return new URL(icon).pathname.replace(/^\/+/, '');
  } catch {
    return icon;
  }
};

export const createInitialValues = (form?: any, formType?: string) => {
  const formTypeValue = form?.type || (formType as EvaluationFormTypes) || EvaluationFormTypes.MANAGER;

  const employeeVisibility = form?.employee_visibility ?? (formTypeValue !== EvaluationFormTypes.MANAGER);

  return {
    title: form?.title || '',
    status: form?.status || EPerformanceFormStatus.DRAFT,
    icon: normalizeIconPath(form?.icon) || 'default/forms/account-circle.png',
    color: form?.color || '#007AFF',
    type: formTypeValue,
    settings: {
      employeeVisibility,
    },
  };
};

